import styled from "@emotion/styled";

export const AboutCardHero = styled.div`
  h3 {
    color: var(--chakra-colors-blue700);
    font-weight: 600;
    margin-bottom: var(--chakra-space-7);
  }

  p {
    color: var(--chakra-colors-black);
    margin-bottom: var(--chakra-space-7);
  }

  button {
    margin-bottom: var(--chakra-space-2);
  }
`;

export const SolutionCardHero = styled.div`
  h3 {
    color: var(--chakra-colors-misc750);
    font-weight: 600;
    margin-bottom: var(--chakra-space-7);
  }

  p {
    color: var(--chakra-colors-black);
    margin-bottom: var(--chakra-space-7);
    font-size: var(--chakra-fontSizes-r);
  }

  button {
    margin-bottom: var(--chakra-space-2);
  }
`;

export const ExperienceHero = styled.div`
  h1 {
    text-align: center;
    margin-bottom: var(--chakra-space-10);
  }
  h3 {
    text-align: center;
    margin: var(--chakra-space-10) var(--chakra-space-16);
    line-height: var(--chakra-space-10);
  }
  p {
    margin-bottom: var(--chakra-space-8);
  }
`;
